/**
 * Deep-links into a snippets/faq.liquid row: if the page loads with a
 * `#faq-<slug>` hash, opens the matching `[data-faq-item]` (native
 * <details>) and scrolls it into view. Works across pages - a Help Centre
 * link can point at `/pages/faq#faq-how-do-i-find-my-model` and land with
 * that row already expanded.
 */
function openFaqFromHash() {
  const hash = window.location.hash;
  if (!hash.startsWith('#faq-')) return;

  const target = document.querySelector(`[data-faq-item]${hash}`);
  if (!target) return;

  target.open = true;
  target.scrollIntoView({ behavior: 'smooth', block: 'start' });
}

window.addEventListener('hashchange', openFaqFromHash);

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', openFaqFromHash);
} else {
  openFaqFromHash();
}
